import axios from "axios";
import constants from "../constants";
import generateCorrelationId from "./generateCorrelationId";
import getCurrentDatetime from "./getCurrentDatetime";

export default function axiosGet({
  url,
  headers,
  callback,
  errorCallback,
  responseType,
}) {
  axios
    .get(url, {
      headers: {
        ...headers,
        "X-Transmission-Date-Time": getCurrentDatetime(),
        "X-Correlation-Id": generateCorrelationId(),
        "X-Api-Key": constants.API_KEY,
      },
      responseType: responseType,
    })
    .then((res) => {
      if (res.data.statusCode === constants.HTTP_STATUS_SUCCESS) {
        callback(res.data);
      } else {
        errorCallback(res.data);
      }
    })
    .catch((err) => {
      errorCallback(err);
    });
}
